package com.devi3east.bashbuddy.cart.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.detail.ui.LoadingScreen

@Composable
fun StripeSuccessScreen(
    appState: AppState,
    sessionId: String,
    orgId: String
) {
    val navController = appState.navController

    LaunchedEffect(sessionId) {
        appState.cartViewModel.confirmPurchase(
            sessionId = sessionId,
            orgId = orgId,
            onSuccess = {
                appState.cartViewModel.removeItemsForOrganization(orgId)

                navController.navigate(Screen.CartScreen.route) {
                    popUpTo(Screen.EventsScreen.route)
                    launchSingleTop = true
                }
            },
            onFailure = { /* ignore + retry */ }
        )

        // Fallback — webhook probably succeeded anyway
        navController.navigate(Screen.CartScreen.route)
    }

    LoadingScreen()
}